import React from 'react';
import { BeefCoPageContext, useBeefCoProject } from '@beefco/sdk-shared';
import { ClassifyCollector, generateClassName } from '@beefco/lib-classify';
import { ConditionalPlatformHooker, Renderer } from "../internals/components";
import { AdaptiveNodesProvider } from "../structure/components";
import { useFastPlatformCheck } from "../internals/hooks";
import { HardcodeBoundary } from "../hardcode-dsl";
export var createBeefCoPage = function createBeefCoPage(_ref) {
  var pageId = _ref.pageId,
    pageSlug = _ref.pageSlug,
    library = _ref.library;
  var BeefCoPage = function BeefCoPage() {
    var isPlatform = useFastPlatformCheck();
    var _useBeefCoProject = useBeefCoProject(),
      externalPageDSL = _useBeefCoProject.externalPageDSL;
    return /*#__PURE__*/React.createElement(ClassifyCollector, {
      classGenerator: generateClassName
    }, /*#__PURE__*/React.createElement(HardcodeBoundary, {
      externalDSL: externalPageDSL,
      pageSlug: pageSlug
    }, function (pageDSL) {
      return pageDSL && /*#__PURE__*/React.createElement(BeefCoPageContext.Provider, {
        value: pageDSL
      }, isPlatform && /*#__PURE__*/React.createElement(ConditionalPlatformHooker, {
        libraryDSL: library.dsl,
        libraryRootPath: library.rootPath,
        pageId: pageId,
        pageSlug: pageSlug
      }), pageDSL.coreDSL && /*#__PURE__*/React.createElement(AdaptiveNodesProvider, {
        components: library.source,
        coreDSL: pageDSL.coreDSL
      }, /*#__PURE__*/React.createElement(Renderer, null)));
    }));
  };
  return BeefCoPage;
};